import { Injectable } from '@angular/core';
import { userModuleClassProgressMock } from '../../mocks/interfaces/user-module-class-progress.mock';
import { UserModuleClassProgress } from '../../models/interfaces/user-module-class-progress.interface';

@Injectable({
  providedIn: 'root',
})
export class UserModuleClassProgressService {

  public getByUserAndClassIds(userId: string, classIds: string[]): Promise<UserModuleClassProgress[]> {
    return this.getByUserAndClassIdsMocked(userId, classIds);
  }

  public updateProgress(userId: string, classId: string, progress: number): Promise<UserModuleClassProgress> {
    return this.updateProgressMocked(userId, classId, progress);
  }

  //#region Fake Backend

  public getByUserAndClassIdsMocked(userId: string, classIds: string[]): Promise<UserModuleClassProgress[]> {
    return Promise.resolve(
      userModuleClassProgressMock.filter((item) => item.userId === userId && classIds.includes(item.classId)),
    );
  }

  public updateProgressMocked(userId: string, classId: string, progress: number): Promise<UserModuleClassProgress> {
    const now = new Date();
    const existing = userModuleClassProgressMock.find((item) => item.userId === userId && item.classId === classId);

    if (existing) {
      existing.progress = progress;
      existing.lastAccessedAt = now;
      existing.completedAt = progress >= 100 ? (existing.completedAt ?? now) : existing.completedAt;
      existing.updatedAt = now;
      return Promise.resolve(existing);
    }

    const entry: UserModuleClassProgress = {
      id: `umcp-${Date.now()}`,
      userId,
      classId,
      progress,
      startedAt: now,
      completedAt: progress >= 100 ? now : undefined,
      lastAccessedAt: now,
      createdAt: now,
      updatedAt: now,
      isActive: true,
    };

    userModuleClassProgressMock.push(entry);
    return Promise.resolve(entry);
  }

  public updatePositionMocked(userId: string, classId: string, position: number): Promise<UserModuleClassProgress> {
    const now = new Date();
    const existing = userModuleClassProgressMock.find((item) => item.userId === userId && item.classId === classId);

    if (existing) {
      existing.position = position;
      existing.lastAccessedAt = now;
      existing.updatedAt = now;
      return Promise.resolve(existing);
    }

    const entry: UserModuleClassProgress = {
      id: `umcp-${Date.now()}`,
      userId,
      classId,
      progress: 0,
      position,
      startedAt: now,
      lastAccessedAt: now,
      createdAt: now,
      updatedAt: now,
      isActive: true,
    };

    userModuleClassProgressMock.push(entry);
    return Promise.resolve(entry);
  }

  //#endregion
}
